/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Temporisationfrostfreemode3Inputs */



/**
* | output |
* | --- |
* | "Frost-free mode temporization" |
*
* @param {Br_History_Key_Temporisationfrostfreemode3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_temporisationfrostfreemode3 = /** @type {((inputs?: Br_History_Key_Temporisationfrostfreemode3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Temporisationfrostfreemode3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Frost-free mode temporization")
	return /** @type {LocalizedString} */ ("Temporisation mode hors gel")
});
export { br_history_key_temporisationfrostfreemode3 as "br_history_key_temporisationFrostFreeMode" }